export default __webpack_public_path__ + "static/media/page-cropped.acb3d113.jpg";